export default "__VITE_ASSET__b13f1b52__"